module.exports = __webpack_public_path__ + "static/img/avatar.88ff8581.png";